import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/zh-cn/services/toxicology/environmental-risk-assessment-era")({
  beforeLoad: () => { throw redirect({ href: "/zh-cn/services/regulatory-toxicology/environmental-risk-assessment-era", statusCode: 301 }); },
});
